var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"close-modal-icon"},[_c('inline-svg',{attrs:{"src":require('./close.svg'),"width":"21","height":"21"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }